export default "__VITE_ASSET__DQmuDqbA__"